<script>
import UiStepper from '../ui/Stepper';
import UiSubheader from '../ui/Subheader';
import UiHint from '../ui/Hint';
import UiStepInfo from '../send-pressage-view/StepInfo';
import UiStepBubbles from '../send-pressage-view/StepBubbles';
import UiStepTransitions from '../send-pressage-view/StepTransitions';
import UiStepMessage from '../send-pressage-view/StepMessage';
import UiStepBanners from '../send-pressage-view/StepBanners';
import UiStepNotificationImages from '../send-pressage-view/StepNotificationImages';
import UiStepAdvertisementImages from '../send-pressage-view/StepAdvertisementImages';
import UiStepExtendedBanners from '../send-pressage-view/StepExtendedBanners';
import UiStepIOSExtendedNotification from '../send-pressage-view/StepIOSExtendedNotification';
import UiStepIOSExtendedVisualNotification from '../send-pressage-view/StepIOSExtendedVisualNotification';
import UiStepIOSAppleWatch from '../send-pressage-view/StepIOSAppleWatch';
import UiBottomSheet from '../send-pressage-view/BottomSheet';
import UiPhonePreview, {
    VIEW_NONE,
    VIEW_BUBBLE,
    VIEW_TRANSITION,
    VIEW_MESSAGE,
    VIEW_BANNER,
    VIEW_ANDROID_BANNER,
    VIEW_ANDROID_ADV,
    VIEW_ANDROID_EXT_BANNER,
    VIEW_ANDROID_BUBBLE,
    VIEW_IOS_EXT_NOTIFICATION,
    VIEW_IOS_APPLE_WATCH,
    MESSAGE_TYPE_TEXT,
    MESSAGE_TYPE_IFRAME,
    MESSAGE_TYPE_IMAGES,
    DEVICE_ANDROID,
    DEVICE_IPHONE,
    DEVICE_APPLEWATCH,
    MESSAGE_TYPE_SEYU2ABCD,
} from '../ui/PhonePreview';
import UiButton from '../ui/Button';
import UiModal from '../ui/Modal';
import { store } from '../../functions/mixins';
import * as sdk from '../../functions/sdk';
import { getPremadeImageSizeLimit } from '../../functions/helpers';
import moment from 'moment';
import { drawFurge01, drawFurge02, drawSeyu1, drawSeyu2 } from '../../functions/canvasUtils.js';
import { VIEW_IOS_EXT_VISUAL_NOTIFICATION } from '../ui/PhonePreview.vue';
import queryString from 'query-string';
import * as crossPopup from '../../functions/crossPopup';

const getBubbleBanner = b => `https://s3-us-west-2.amazonaws.com/brand-pics/${b.groupId}_fallback/fallback_${b.fileName}.png`;
const getBubbleCube = b => `https://s3-us-west-2.amazonaws.com/brand-pics/${b.groupId}_fallback/fallback_banner_${b.fileName}.png`;
const getBubbleIOS = b => `https://s3-us-west-2.amazonaws.com/brand-pics/${b.groupId}/${b.fileName}.png`;

const decodeParam = (raw, isJSON) => {
  if (isJSON) {
    return JSON.parse(atob(decodeURIComponent(raw)));
  } else {
    return decodeURIComponent(atob(raw));
  }
};

export default {
    components: {
        UiStepper,
        UiSubheader,
        UiHint,
        UiStepInfo,
        UiStepBubbles,
        UiStepTransitions,
        UiStepMessage,
        UiStepBanners,
        UiBottomSheet,
        UiPhonePreview,
        UiStepNotificationImages,
        UiStepAdvertisementImages,
        UiStepExtendedBanners,
        UiStepIOSExtendedNotification,
        UiStepIOSExtendedVisualNotification,
        UiStepIOSAppleWatch,
        UiButton,
        UiModal,
    },
    mixins: [store],
    data: () => ({
        sending: false,
        sendFailed: false,
        sendSuccess: false,
        successData: {},
        steps: [],
        currentStep: 1,
        stepper: [],
        data: null,
        phoneAffixOffset: 0,
        createdModal: false,
    }),
    computed: {
        isNextAvaiable() {
            const { message } = this.data;
            const step = this.currentStep;
            switch (this.currentStep) {
                case 1:
                    if (this.data.isModNews) {
                        if (this.data.title.trim().length && this.data.notificationText.trim().length && this.data.modNewsText.trim().length) {
                            if (this.data.modNewsBackgrounds !== null) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                        return false;
                    }
                    const forceAndroid = !!this.$route.query.forceAndroid;
                    if ((!forceAndroid && !this.isAndroidOnly) && !this.data.notificationText.trim().length) {
                        return false;
                    }
                    return this.data.title.trim().length && this.data.sender.trim().length;
                case 2:
                    return !!this.data.notificationImage;
                case 3:
                    return true;
                    //return !!this.data.advertisementImage;
                case 4:
                    return true;
                case 5:
                    return true;
                    //return !!this.data.bubble;
                case 6:
                    return !!this.data.iosExtendedNotification;
                case 7:
                    //return !!this.data.iosExtendedVisualNotification;
                    return true;
                case 8:
                    return !!this.data.iosAppleWatch;
                case 9:
                    const urlChecker = new RegExp(/([-a-zA-Z0-9_]+):\/\/([-a-zA-Z0-9()@:%_\+.~#?&//=]+)/gi);
                    if (message.type === 'html') {
                        return message.html.url.length && message.html.url.match(urlChecker);
                    } else if (message.type === 'premade') {
                        switch (message.premade.tab) {
                            case 'basic':
                                if (!message.premade.image) {
                                    return false;
                                }
                                break;
                            case 'link':
                                if (!message.premade.image || !message.premade.url.length || !message.premade.url.match(urlChecker)) {
                                    return false;
                                }
                                break;
                            case 'yesno':
                                if (!message.premade.image) {
                                    return false;
                                }
                                break;
                            case 'furge01':
                                break;
                            case 'furge02':
                                if (!message.premade.furge02.message.length || !message.premade.furge02.image) {
                                    return false;
                                }
                                break;
                            case 'coupon':
                                if (!message.premade.coupon.txtExpired.length || !message.premade.coupon.image || !message.premade.coupon.txtRedeemed.length) {
                                    return false;
                                }
                                break;
                        }
                        if (message.premade.image && message.premade.image.size > getPremadeImageSizeLimit()) {
                            return false;
                        }
                        return true;
                    } else if (message.type === 'feed') {
                        if (!message.feed.message) {
                            return false;
                        }
                    }
                    return true;
                case 10:
                    return true;
            }
            return false;
        },
        isBackAvaiable() {
            return this.currentStep > 1;
        },
        isRecipientListSet() {
            return !!this.recipientList;
        },
        phonePreviewDevice() {
            return [
                DEVICE_ANDROID,
                DEVICE_ANDROID,
                DEVICE_ANDROID,
                DEVICE_ANDROID,
                DEVICE_ANDROID,
                DEVICE_IPHONE,
                DEVICE_IPHONE,
                DEVICE_APPLEWATCH,
                DEVICE_ANDROID,
                DEVICE_ANDROID,
            ][this.currentStep - 1];
        },
        phonePreviewView() {
            return [
                VIEW_NONE,
                VIEW_ANDROID_BANNER,
                VIEW_ANDROID_ADV,
                VIEW_ANDROID_EXT_BANNER,
                VIEW_ANDROID_BUBBLE,
                VIEW_IOS_EXT_NOTIFICATION,
                VIEW_IOS_EXT_VISUAL_NOTIFICATION,
                VIEW_IOS_APPLE_WATCH,
                VIEW_MESSAGE,
                VIEW_BANNER,
            ][this.currentStep - 1];
        },
        phonePreviewGraphics() {
            const result = {
                androidBanner: this.data.notificationImage
                    ? sdk.getNotificationImageURL(this.data.notificationImage.groupId, this.data.notificationImage.fileName)
                    : null,
                androidAdv: this.data.advertisementImage
                    ? this.data.advertisementImage.backgroundFileName ? sdk.getAdvertisementImageBigURL(this.data.advertisementImage.groupId, this.data.advertisementImage.backgroundFileName) : sdk.getAdvertisementImageURL(this.data.advertisementImage.groupId, this.data.advertisementImage.fileName)
                    : null,
                androidExtBanner: this.data.extendedBanner
                    ? sdk.getExtendedBannerURL(this.data.extendedBanner.groupId, this.data.extendedBanner.fileName)
                    : null,
                androidBubble: this.data.bubble
                    ? sdk.getBubbleImage(this.data.bubble.groupId, this.data.bubble.fileName)
                    : null,
                iosExtNotification: this.data.iosExtendedNotification
                    ? sdk.getIOSExtendedNotificationURL(this.data.iosExtendedNotification.groupId, this.data.iosExtendedNotification.fileName)
                    : null,
                iosExtVisualNotification: this.data.iosExtendedVisualNotification
                    ? sdk.getIOSExtendedNotificationURL(this.data.iosExtendedVisualNotification.groupId, this.data.iosExtendedVisualNotification.fileName)
                    : null,
                iosAppleWatch: this.data.iosAppleWatch
                    ? sdk.getIOSAppleWatchURL(this.data.iosAppleWatch.groupId, this.data.iosAppleWatch.fileName)
                    : null,
            };
            if (this.data.iosExtendedNotification) {
                if (this.data.iosExtendedNotification.id === '[use-bubble]') {
                    result.iosExtNotification = result.androidBubble;
                }
            }
            return result;
        },
        phonePreviewMessage() {
            const {
                type,
                html,
                premade,
                feed,
            } = this.data.message;
            const _seyu1Background = this.data.message.premade.seyu1.background;
            const _seyu1Logo = this.data.message.premade.seyu1.logo;
            const _seyu2Background = this.data.message.premade.seyu2.background;
            const _seyu2Logo = this.data.message.premade.seyu2.logo;
            switch (type) {
                case 'feed':
                    return {
                        type: MESSAGE_TYPE_TEXT,
                        payload: [feed.message],
                    };
                case 'html':
                    switch (html.tab) {
                        case 'app':
                            return {
                                type: MESSAGE_TYPE_TEXT,
                                payload: {
                                    style: {
                                        background: '#E1E1E1',
                                    },
                                    text: this.$t('sendPressageView.previewAppText'),
                                },
                            };
                        case 'web':
                            return {
                                type: MESSAGE_TYPE_IFRAME,
                                payload: html.url,
                            };
                    }
                case 'premade':
                    switch (premade.tab) {
                        case 'basic':
                            return [{
                                type: MESSAGE_TYPE_TEXT,
                                payload: {
                                    style: { background: '#E1E1E1' },
                                },
                            }, {
                                type: MESSAGE_TYPE_IMAGES,
                                payload: [premade.image],
                            }];
                        case 'link':
                            return [{
                                type: MESSAGE_TYPE_TEXT,
                                payload: {
                                    style: { background: '#E1E1E1' },
                                },
                            }, {
                                type: MESSAGE_TYPE_IMAGES,
                                payload: [premade.image],
                            }, {
                                type: MESSAGE_TYPE_TEXT,
                                payload: {
                                    text: this.$t('sendPressageView.premadeLinkMoreInfo'),
                                    innerStyle: {
                                        display: 'block',
                                        position: 'absolute',
                                        top: 'auto',
                                        left: '50%',
                                        bottom: '50px',
                                        transform: 'translate(-50%, 0)',
                                        padding: '10px 30px',
                                        fontWeight: '700',
                                        border: '2px solid #fff',
                                        borderRadius: '30px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,.4)',
                                        background: 'rgba(0,0,0,.6)',
                                        color: '#fff',
                                        whiteSpace: 'nowrap',
                                    },
                                },
                            }];
                        case 'yesno':
                            return [{
                                type: MESSAGE_TYPE_TEXT,
                                payload: {
                                    style: { background: '#E1E1E1' },
                                },
                            }, {
                                type: MESSAGE_TYPE_IMAGES,
                                payload: [premade.image, '/static/img/phone_yesno.png'],
                            }];
                        case 'furge01': {
                            const blob = drawFurge01(premade.furge01);
                            this.data.message.premade.furge01.blob = blob;
                            return {
                                type: MESSAGE_TYPE_IMAGES,
                                payload: premade.furge01.vote ? [blob, '/static/img/phone_yesno.png'] : [blob],
                            };
                        }
                        case 'furge02': {
                            const blob = drawFurge02(premade.furge02);
                            this.data.message.premade.furge02.blob = blob;
                            return {
                                type: MESSAGE_TYPE_IMAGES,
                                payload: [blob],
                            };
                        }
                        case 'coupon': {
                            const layers = [{
                                type: MESSAGE_TYPE_TEXT,
                                payload: {
                                    style: { background: '#E1E1E1' },
                                },
                            }, {
                                type: MESSAGE_TYPE_IMAGES,
                                payload: [premade.coupon.image],
                            }];
                            if (premade.coupon.txtButton.length) {
                                layers.push({
                                    type: MESSAGE_TYPE_TEXT,
                                    payload: {
                                        text: premade.coupon.txtButton,
                                        innerStyle: {
                                            display: 'block',
                                            position: 'absolute',
                                            top: 'auto',
                                            left: '50%',
                                            bottom: '50px',
                                            transform: 'translate(-50%, 0)',
                                            padding: '10px 30px',
                                            fontWeight: '700',
                                            border: '2px solid #fff',
                                            borderRadius: '30px',
                                            boxShadow: '0 2px 4px rgba(0,0,0,.4)',
                                            background: 'rgba(0,0,0,.6)',
                                            color: '#fff',
                                            whiteSpace: 'nowrap',
                                        },
                                    },
                                });
                            }
                            if (premade.coupon.overlayExpired) {
                                layers.push({
                                    type: MESSAGE_TYPE_TEXT,
                                    payload: {
                                        text: premade.coupon.txtExpired,
                                        style: {
                                            background: 'rgba(0,0,0,.6)',
                                        },
                                        innerStyle: {
                                            display: 'block',
                                            marginTop: '-100px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            color: '#fff',
                                            textAlign: 'center',
                                        },
                                    },
                                });
                            }
                            if (premade.coupon.overlayRedeemed) {
                                layers.push({
                                    type: MESSAGE_TYPE_TEXT,
                                    payload: {
                                        text: premade.coupon.txtRedeemed,
                                        style: {
                                            background: 'rgba(0,0,0,.6)',
                                        },
                                        innerStyle: {
                                            display: 'block',
                                            marginTop: '-100px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            color: '#fff',
                                            textAlign: 'center',
                                        },
                                    },
                                });
                            }
                            return layers;
                        }
                        case 'seyu1': {
                            const blob = drawSeyu1(premade.seyu1);
                            this.data.message.premade.seyu1.blob = blob;
                            return {
                                type: MESSAGE_TYPE_IMAGES,
                                payload: [blob, '/static/img/phone_yesno.png'],
                            };
                        }
                        case 'seyu2': {
                            const blob = drawSeyu2(premade.seyu2);
                            this.data.message.premade.seyu2.blob = blob;
                            return [{
                                type: MESSAGE_TYPE_IMAGES,
                                payload: [blob],
                            }, {
                                type: MESSAGE_TYPE_SEYU2ABCD,
                                payload: {
                                    q: this.data.message.premade.seyu2.question,
                                    a: this.data.message.premade.seyu2.answerA,
                                    b: this.data.message.premade.seyu2.answerB,
                                    c: this.data.message.premade.seyu2.answerC,
                                    d: this.data.message.premade.seyu2.answerD,
                                    colors: {
                                        q: this.data.message.premade.seyu2.colors.question,
                                        a: this.data.message.premade.seyu2.colors.answerA,
                                        b: this.data.message.premade.seyu2.colors.answerB,
                                        c: this.data.message.premade.seyu2.colors.answerC,
                                        d: this.data.message.premade.seyu2.colors.answerD,
                                    },
                                },
                            }];
                        }
                    }
            }
        },
        isDemoMode() {
            return !!this.userInfo.demo;
        },
        phoneAffixStyle() {
            return {
                paddingTop: `${this.phoneAffixOffset}px`,
            };
        },
        hideMainContent() {
            const { iosExtendedNotification } = this.data;
            if (this.currentStep === 8 && iosExtendedNotification) {
                if (iosExtendedNotification.id === '[use-bubble]') {
                    return false;
                }
                const ext = iosExtendedNotification.fileName.split('.').pop().toLowerCase();
                if (ext === 'gif' || ext === 'mp4') {
                    return false;
                }
                return true;
            }
            return false;
        },
        stepHint() {
            switch (this.currentStep) {
                case 2:
                    return this.$t('sendPressageView.stepAndroidNotificationImageHint');
                case 4:
                    return this.$t('sendPressageView.stepAndroidExtendedBannerHint');
                case 5:
                    return this.$t('sendPressageView.stepAndroidBubblesHint');
                case 6:
                    return this.$t('sendPressageView.stepIOSExtendedNotificationHint');
                default:
                    return null;
            }
        },
        disableToogleButton() {
            return this.stepper[8].disabled;
        },
    },
    created() {
        crossPopup.closeAllInstances();
        if (this.userInfo.hideToolbox) {
            this.$router.push({
                name: 'settings',
            });
        }
        this.resetData();
        if (this.stepper[0].disabled) {
            this.next();
        }
        sdk.pressengerControl.listBrandPics().then(banners => {
            if (!banners.length) {
                this.stepper[9].disabled = true;
            }
        });
    },
    mounted() {
        this._phoneAffixHandler = () => {
            const container = this.$refs.phoneAffix;
            if (container) {
                const top = container.getBoundingClientRect().top;
                if (top < 100) {
                    this.phoneAffixOffset = -(top - 100);
                } else {
                    this.phoneAffixOffset = 0;
                }
            }
        };
        window.addEventListener('scroll', this._phoneAffixHandler);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this._phoneAffixHandler);
    },
    methods: {
        resetData() {
            const params = queryString.parse(location.search);
            window.confirmBeforeRouteChange = false;
            const forceAndroid = !!this.$route.query.forceAndroid;
            const isModNews = !!this.$route.query.modNews;
            this.stepper = [
                { title: 'sendPressageView.stepInfoTitle', disabled: false },
                { title: 'sendPressageView.stepAndroidNotificationImageTitle', disabled: false },
                { title: 'sendPressageView.stepAndroidAdvertisementImageTitle', disabled: isModNews },
                { title: 'sendPressageView.stepAndroidExtendedBannerTitle', disabled: this.isAndroidExtBannerEnabled === false },
                { title: 'sendPressageView.stepAndroidBubblesTitle', disabled: !!this.userInfo.disableBubble || isModNews },
                { title: 'sendPressageView.stepIOSExtendedNotification', disabled: forceAndroid || this.isAndroidOnly },
                { title: 'sendPressageView.stepIOSExtendedVisualNotification', disabled: (forceAndroid || this.isAndroidOnly) || !this.userInfo.secondLogoEnabled },
                { title: 'sendPressageView.stepIOSAppleWatch', disabled: (forceAndroid || this.isAndroidOnly) || isModNews },
                { title: 'sendPressageView.stepMessageTitle', disabled: false },
                { title: 'sendPressageView.stepBannersTitle', disabled: isModNews },
            ];
            const d = moment().add(1, 'hour').minutes(0);
            const pad = num => num < 10 ? `0${num}` : `${num}`;
            this.currentStep = params.step ? parseInt(decodeParam(params.step, false)) : 1;
            this.data = {
                isModNews,
                modNewsTemplate: 'basic',
                modNewsText: '',
                modNewsAndroid: null,
                modNewsIOS: null,
                modNewsBackgrounds: null,
                modNewsLastBackground: null,
                title: params.campaignName ? decodeParam(params.campaignName, false) : '',
                sender: this.userInfo.userName,
                bubble: null,
                transition: null,
                banner: null,
                notificationText: params.iosNotificationText ? decodeParam(params.iosNotificationText, false) : '',
                notificationImage: params.notificationImage ? decodeParam(params.notificationImage, true) : null,
                advertisementImage: params.advertisementImage ? decodeParam(params.advertisementImage, true) : null,
                extendedBanner: params.extendedBanner ? decodeParam(params.extendedBanner, true) : null,
                iosExtendedNotification: params.iosExtendedNotification ? decodeParam(params.iosExtendedNotification, true) : null,
                iosAppleWatch: params.iosAppleWatch ? decodeParam(params.iosAppleWatch, true) : null,
                iosExtendedVisualNotification: params.iosExtendedVisualNotification ? decodeParam(params.iosExtendedVisualNotification, true) : null,
                hint: false,
                forcePreviewLoading: false,
                message: {
                    type: (!!this.userInfo.premadeFirst && this.userInfo.enablePremade === true) ? 'premade' : 'html',
                    html: {tab: 'web', url: ''},
                    premade: {
                        tab: 'basic',
                        image: null,
                        imageSrc: null,
                        url: '',
                        furge01: {
                            image: null,
                            realImage: null,
                            logo: null,
                            header: 'Petőfi nyomda / Rugalmas munkaidő / Hosszútávú lehetőség',
                            title: 'Nyomdai kisegito',
                            subtitle: 'nettó 1600 Ft/óra',
                            bg: '#74BF44',
                            vote: true,
                            blob: null,
                            imageUploading: false,
                        },
                        furge02: {
                            image: null,
                            realImage: null,
                            message: 'Petőfi nyomda / Rugalmas munkaidő / Hosszútávú lehetőség',
                            blob: null,
                            imageUploading: false,
                        },
                        coupon: {
                            image: null,
                            expire: '',
                            blob: null,
                            txtButton: '',
                            txtExpired: '',
                            txtRedeemed: '',
                            overlayExpired: false,
                            overlayRedeemed: false,
                            imageUploading: false,
                        },
                        seyu1: {
                            background: null,
                            logo: null,
                            title: 'IGEN VAGY NEM',
                            message: 'KIJUT A MAGYAR VALOGATOTT AZ EB-RE?',
                            colors: {
                                title: '#044505',
                                message: '#044505',
                            },
                            blob: null,
                        },
                        seyu2: {
                            background: null,
                            logo: null,
                            question: 'Szerinted ki jatzsott ma a legjobban a valogatottban?',
                            answerA: 'Gulasci Peter',
                            answerB: 'Dzsudzsak Balazs',
                            answerC: 'Kleinheisler Laszlo',
                            answerD: 'Szalai Adam',
                            colors: {
                                question: '#00a551',
                                answerA: '#00a551',
                                answerB: '#00a551',
                                answerC: '#00a551',
                                answerD: '#00a551',
                            },
                            blob: null,
                        },
                    },
                    feed: {
                        image: null,
                        imageCropped: null,
                        imageUrl: null,
                        imageCropperData: null,
                        message: '',
                        url: '',
                    },
                },
                method: {sendToAll: true, recipients: '', topic: ''},
                sendingMethod: this.userInfo.canSendToAll ? 'all' : 'custom',
                time: {
                    sendNow: true,
                    year: pad(d.year()),
                    month: pad(d.month() + 1),
                    day: pad(d.date()),
                    hours: pad(d.hours()),
                    minutes: pad(d.minutes()),
                },
                recipientList: sdk.getRecipientList(),
                bubbleDisabled: false,
                extraPushIframe: null,
                channelId: '',
            };
        },
        next(step = 1) {
            window.confirmBeforeRouteChange = true;
            if (this.currentStep + step === 11) {
                this.$refs.bottomSheet.setExpanded(true);
            } else if (this.currentStep + step > 0) {
                this.currentStep += step;
                if (this.stepper[this.currentStep - 1].disabled) {
                    this.next(step);
                } else if (this.currentStep === 9) {
                    const furge01LogoImg = new Image;
                    furge01LogoImg.onload = () => {
                        this.data.message.premade.furge01.logo = furge01LogoImg;
                    };
                    furge01LogoImg.src = '/static/img/phone_furge.png';
                }
            }
        },
        onStepPreviewPrevClicked() {
            const nav = this.$refs.nav;
            if (nav && nav.onPrevClicked) {
                nav.onPrevClicked();
            }
        },
        onStepPreviewNextClicked() {
            const nav = this.$refs.nav;
            if (nav && nav.onNextClicked) {
                nav.onNextClicked();
            }
        },
        send(saveAsWelcome = false) {
            if (!saveAsWelcome) {
                this.sending = true;
                this.sendFailed = false;
                this.sendSuccess = false;
            }
            const {
                title,
                sender,
                bubble,
                banner,
                notificationImage,
                advertisementImage,
                extendedBanner,
                iosExtendedNotification,
                iosExtendedVisualNotification,
                iosAppleWatch,
                message,
                method,
                time,
                sendingMethod,
                recipientList,
                bubbleDisabled,
                notificationText,
                channelId,
            } = this.data;
            let type = message.type;
            if (type === 'premade') {
                switch (message.premade.tab) {
                    case 'furge01':
                    case 'seyu1':
                        type = 'yesno';
                        break;
                    case 'furge02':
                        type = 'basic';
                        break;
                    case 'coupon':
                        type = 'coupon';
                        break;
                    case 'seyu2':
                        type = 'seyu2';
                        break;
                    default:
                        type = message.premade.tab;
                }
            }
            const sendTime = `${time.year}-${time.month}-${time.day} ${time.hours}:${time.minutes}`;
            let url = message.html.url;
            let image = null;
            let text = '';
            if (message.type === 'premade') {
                url = message.premade.tab === 'link' ? message.premade.url : '';
                if (['basic', 'link', 'yesno'].includes(message.premade.tab)) {
                    image = message.premade.image;
                }
                if (message.premade.tab === 'furge01') {
                    image = message.premade.furge01.blob;
                }
                if (message.premade.tab === 'furge02') {
                    image = message.premade.furge02.blob;
                }
                if (message.premade.tab === 'coupon') {
                    const coupon = message.premade.coupon;
                    image = coupon.image;
                    const txtExpire = encodeURI(encodeURI(coupon.expire));
                    const txtButton = encodeURI(encodeURI(coupon.txtButton));
                    const txtExpired = encodeURI(encodeURI(coupon.txtExpired));
                    const txtRedeemed = encodeURI(encodeURI(coupon.txtRedeemed));
                    text = `${txtExpire} ${txtButton} ${txtExpired} ${txtRedeemed}`;
                }
                if (message.premade.tab === 'seyu1') {
                    image = message.premade.seyu1.blob;
                }
                if (message.premade.tab === 'seyu2') {
                    const seyu2 = message.premade.seyu2;
                    image = seyu2.blob;
                    const txtQ = encodeURI(encodeURI(seyu2.question));
                    const txtA = encodeURI(encodeURI(seyu2.answerA));
                    const txtB = encodeURI(encodeURI(seyu2.answerB));
                    const txtC = encodeURI(encodeURI(seyu2.answerC));
                    const txtD = encodeURI(encodeURI(seyu2.answerD));
                    const colQ = encodeURI(encodeURI(seyu2.colors.question));
                    const colA = encodeURI(encodeURI(seyu2.colors.answerA));
                    const colB = encodeURI(encodeURI(seyu2.colors.answerB));
                    const colC = encodeURI(encodeURI(seyu2.colors.answerC));
                    const colD = encodeURI(encodeURI(seyu2.colors.answerD));
                    text = `${txtQ} ${txtA} ${txtB} ${txtC} ${txtD} ${colQ} ${colA} ${colB} ${colC} ${colD}`;
                }
            }
            if (message.type === 'feed') {
                type = 'html';
                url = 'app://main?feed=1';
            }
            let sMethod = recipientList ? `recipientList:${recipientList}` : null;
            if (saveAsWelcome) {
                return new Promise((resolve, reject) => {
                    sdk.pressengerControl.generatePressage({
                        name: title,
                        sender: sender,
                        text: text,
                        image: image || '',
                        phoneNumbers: '',
                        type: type,
                        htmlTemplateName: '',
                        pos: '0',
                        link: url,
                        bannerId: banner ? banner.id : 0,
                        logoName: bubble ? bubble.fileName : '',
                        notificationImageName: notificationImage ? notificationImage.fileName : '',
                        advertisementImageName: advertisementImage ? advertisementImage.fileName : '',
                        extendedNotificationImageName: extendedBanner ? extendedBanner.fileName : '',
                        iOSLogoName: iosExtendedNotification && iosExtendedNotification.id !== '[use-bubble]' ? iosExtendedNotification.fileName : '',
                        iOSSecondImageName:  iosExtendedVisualNotification && iosExtendedVisualNotification.id !== '[use-bubble]' ? iosExtendedVisualNotification.fileName : '',
                        iOSWatchImageName: iosAppleWatch ? iosAppleWatch.fileName : '',
                        disableBubble: !bubble,
                        message: notificationText,
                    }).then(pressageId => {
                        sdk.pressengerControl.setWelcomePressageId(pressageId).then(() => {
                            resolve();
                        }).catch(() => {
                            reject();
                        })
                    }).catch(() => {
                        reject();
                    });
                });
            } else {
                switch (sendingMethod) {
                    case 'all':
                        if (sMethod === null) {
                            sMethod = 'true';
                        }
                    case 'custom':
                        if (sMethod === null) {
                            sMethod = 'false';
                        }
                    case 'topic':
                        if (sMethod === null) {
                            sMethod = `topic:${method.topic}`;
                        }
                        sdk.pressengerControl.sendMassPressage({
                            name: title,
                            sender: sender,
                            text: text,
                            image: image || '',
                            phoneNumbers: sMethod === 'false' ? method.recipients : '',
                            type: type,
                            htmlTemplateName: '',
                            pos: '0',
                            link: url,
                            sendToAll: sMethod,
                            bannerId: banner ? banner.id : 0,
                            sendDate: time.sendNow ? '' : sendTime,
                            logoName: bubble ? bubble.fileName : '',
                            notificationImageName: notificationImage ? notificationImage.fileName : '',
                            advertisementImageName: advertisementImage ? advertisementImage.fileName : '',
                            extendedNotificationImageName: extendedBanner ? extendedBanner.fileName : '',
                            iOSLogoName: iosExtendedNotification && iosExtendedNotification.id !== '[use-bubble]' ? iosExtendedNotification.fileName : '',
                            iOSSecondImageName: iosExtendedVisualNotification && iosExtendedVisualNotification.id !== '[use-bubble]' ? iosExtendedVisualNotification.fileName : '',
                            iOSWatchImageName: iosAppleWatch ? iosAppleWatch.fileName : '',
                            disableBubble: !bubble,
                            message: notificationText,
                            channelId: channelId,
                            feedMessage: message.type === 'feed' ? message.feed.message : '',
                            feedUrl: message.type === 'feed' ? (message.feed.url || '') : '',
                            feedImage: message.type === 'feed' ? (message.feed.imageCropped || '') : '',
                        }).then(response => {
                            this.successData = {
                                type: time.sendNow ? 'sent' : 'delayed',
                                pressageId: response,
                            };
                            this.sendSuccess = true;
                            this.resetData();
                        }).catch(() => {
                            this.sendFailed = true;
                        }).finally(() => {
                            this.sending = false;
                        });
                        break;
                    case 'generate':
                    case '3rdparty':
                        sdk.pressengerControl.generatePressage({
                            name: title,
                            sender: sender,
                            text: text,
                            image: image || '',
                            phoneNumbers: sMethod === 'false' ? method.recipients : '',
                            type: type,
                            htmlTemplateName: '',
                            pos: '0',
                            link: url,
                            bannerId: banner ? banner.id : 0,
                            logoName: bubble ? bubble.fileName : '',
                            notificationImageName: notificationImage ? notificationImage.fileName : '',
                            advertisementImageName: advertisementImage ? advertisementImage.fileName : '',
                            extendedNotificationImageName: extendedBanner ? extendedBanner.fileName : '',
                            iOSLogoName: iosExtendedNotification && iosExtendedNotification.id !== '[use-bubble]' ? iosExtendedNotification.fileName : '',
                            iOSWatchImageName: iosAppleWatch ? iosAppleWatch.fileName : '',
                            disableBubble: !bubble,
                            message: notificationText,
                            channelId: channelId,
                            feedMessage: message.type === 'feed' ? message.feed.message : '',
                            feedUrl: message.type === 'feed' ? (message.feed.url || '') : '',
                            feedImage: message.type === 'feed' ? (message.feed.imageCropped || '') : '',
                        }).then(pressageId => {
                            let purl = this.userInfo.extraPushUrl;
                            if (sendingMethod === '3rdparty' && purl) {
                                sdk.pressengerControl.getSessionId().then(sessionId => {
                                    if (purl.indexOf('${sessionId}') > - 1) {
                                        purl = purl.replace('${sessionId}', sessionId);
                                    }
                                    if (purl.indexOf('${ID}') > - 1) {
                                        purl = purl.replace('${ID}', pressageId);
                                    } else {
                                        purl = purl + pressageId;
                                    }
                                    this.sendSuccess = true;
                                    this.successData = {
                                        type: 'export',
                                        pressageId,
                                        purl,
                                    };
                                    //this.createdModal = true;
                                    window.confirmBeforeRouteChange = false;
                                    this.sending = false;
                                    this.data.extraPushIframe = purl;
                                    /*
                                    this.$router.push({
                                        name: 'outside',
                                        params: {
                                            outUrl: btoa(purl),
                                            backRoute: btoa(JSON.stringify({name: 'send'})),
                                        },
                                    });
                                    */
                                }).catch(() => {
                                    this.sendFailed = true;
                                    this.sending = false;
                                });
                            } else {
                                this.sending = false;
                                this.sendSuccess = true;
                                this.successData = {
                                    type: 'export',
                                    pressageId,
                                };
                                this.resetData();
                                window.parent.postMessage({
                                    title,
                                    text: notificationText,
                                    extra: {
                                        pressageId,
                                    },
                                    ios: {
                                        aps: {
                                            sound: 'default.caf',
                                            category: 'animgif',
                                            'mutable-content': 1
                                        }
                                    }

                                }, "https://app.pushwize.com");
                            }
                        }).catch(() => {
                            this.sendFailed = true;
                            this.sending = false;
                        });
                        break;
                }
            }
        },
        skipStep() {
            const step = this.currentStep;
            this.stepper[step - 1].disabled = true;
            if (step === 10) {
                this.currentStep = 9;
                this.$refs.bottomSheet.setExpanded(true);
            } else {
                this.next();
            }
        },
        setStep(step, disabled) {
            if (step !== this.currentStep) {
                this.stepper[step - 1].disabled = disabled;
            }
        },
        setPreviewType(type) {
            this.previewType = type;
        },
        normalizeStep(step = 1) {
            if (this.stepper[this.currentStep - 1].disabled) {
                this.next(step);
            }
        },
        openGeneratedPressage() {
            const wnd = window.open(this.successData.purl, '_blank', '', false);
            wnd.focus();
            this.resetData();
            this.createdModal = false;
        },
    },
}
</script>

<template>
    <div class="SendPressageView">
        <ui-modal :visible="createdModal">
            <div class="Alert AlertSuccess">
                <p>{{ $t('sendPressageView.messageOut') }}</p>
            </div>
            <template>
                <div class="FlexRow JustifyEnd">
                    <ui-button @click.native="openGeneratedPressage()" class="white primary">
                        {{ $t('sendPressageView.continueOut') }}
                    </ui-button>
                </div>
            </template>
        </ui-modal>
        <div class="StepContentWrapper">
            <ui-stepper :step="currentStep" :steps="stepper" />
            <div :class="['StepContent', {FirstStep: currentStep === 1}]">
                <div :class="['StepMain', {StepMainHide: hideMainContent}]">
                    <ui-step-info
                        v-if="currentStep === 1"
                        v-model="data"
                        :showSuccess="sendSuccess"
                        :successData="successData"
                        :disableNext="!isNextAvaiable"
                        :next="next"
                    />
                    <ui-step-notification-images
                        v-if="currentStep === 2"
                        v-model="data"
                        :showSuccess="sendSuccess"
                        :successData="successData"
                        :disableNext="!isNextAvaiable"
                        :next="next"
                        :setStep="setStep"
                        ref="nav"
                    />
                    <ui-step-advertisement-images
                        v-if="currentStep === 3"
                        v-model="data"
                        :showSuccess="sendSuccess"
                        :successData="successData"
                        :disableNext="!isNextAvaiable"
                        :next="next"
                        ref="nav"
                    />
                    <ui-step-extended-banners
                        v-if="currentStep === 4"
                        v-model="data"
                        :showSuccess="sendSuccess"
                        :successData="successData"
                        :disableNext="!isNextAvaiable"
                        :next="next"
                        ref="nav"
                    />
                    <ui-step-bubbles
                        v-else-if="currentStep === 5"
                        v-model="data"
                        :setStep="setStep"
                        ref="nav"
                    />
                    <ui-step-i-o-s-extended-notification
                        v-if="currentStep === 6"
                        v-model="data"
                        :showSuccess="sendSuccess"
                        :successData="successData"
                        :disableNext="!isNextAvaiable"
                        :next="next"
                        ref="nav"
                    />
                    <ui-step-i-o-s-extended-visual-notification
                        v-if="currentStep === 7"
                        v-model="data"
                        :showSuccess="sendSuccess"
                        :successData="successData"
                        :disableNext="!isNextAvaiable"
                        :next="next"
                        ref="nav"
                    />
                    <ui-step-i-o-s-apple-watch
                        v-if="currentStep === 8"
                        v-model="data"
                        :showSuccess="sendSuccess"
                        :successData="successData"
                        :disableNext="!isNextAvaiable"
                        :next="next"
                        ref="nav"
                    />
                    <ui-step-message
                        v-model="data"
                        v-else-if="currentStep === 9"
                    />
                    <ui-step-banners
                        v-model="data"
                        v-else-if="currentStep === 10"
                        ref="nav"
                        :skipStep="skipStep"
                        :disabled="stepper[9].disabled"
                    />
                </div>
                <div class="StepPreview" ref="phoneAffix" :style="isInflugamers ? {} : phoneAffixStyle" v-if="!isInflugamers || currentStep === 8">
                    <!--
                    <ui-subheader class="Simple" v-if="currentStep !== 8 || data.message.type !== 'html'">
                        {{ $t('sendPressageView.previewTitle') }}
                        <ui-hint class="Darken Small Abs NoWrap" style="right: -40px" v-if="currentStep === 8">
                            {{ $t('sendPressageView.previewHint') }}
                        </ui-hint>
                    </ui-subheader>
                    -->
                    <div class="PhoneWrapper" v-if="currentStep !== 9 || (data.message.type !== 'html' && data.message.type !== 'feed')">
                        <ui-phone-preview
                            :showDeviceSelect="this.currentStep === 2"
                            :showNavigation="false"
                            :navigationPosition="this.currentStep === 9 ? 'Bottom' : 'Center'"
                            :device="phonePreviewDevice"
                            :view="phonePreviewView"
                            :bubble="data.bubble"
                            :transition="data.transition"
                            :message="phonePreviewMessage"
                            :banner="data.banner"
                            :forceLoading="data.forcePreviewLoading"
                            v-bind="phonePreviewGraphics"
                            @onPrevClick="onStepPreviewPrevClicked()"
                            @onNextClick="onStepPreviewNextClicked()"
                            ref="phone"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="BottomSheetSpaceFix" v-if="currentStep > 1"></div>
        <ui-bottom-sheet
            v-model="data"
            :step="currentStep"
            :disableBack="!isBackAvaiable"
            :disableNext="!isNextAvaiable"
            :showLastFrom="9"
            :sendFailed="sendFailed"
            :next="next"
            :send="send"
            :isSending="sending"
            :normalizeStep="normalizeStep"
            :isDemoMode="isDemoMode"
            :restart="resetData"
            ref="bottomSheet"
            :hint="stepHint"
            :disableToogleButton="disableToogleButton"
            :previewData="phonePreviewGraphics"
        />
    </div>
</template>

<style lang="stylus" scoped>
.SendPressageView
    flex 1 1 auto
    display flex
    flex-direction column
    justify-content flex-start
    align-items stretch
    .StepContentWrapper
        flex 1 0 auto
        display flex
        flex-direction column
        .StepContent
            flex 1 0 auto
            display flex
            flex-direction row
            justify-content center
            align-items flex-start
            width 100%
            max-width 1170px
            padding 70px 20px
            margin 0 auto
            .StepMain
                display flex
                flex 1 1 auto
                flex-direction column
                &.StepMainHide {
                    display: none;
                }
            .StepPreview
                display flex
                flex-direction column
                justify-content flex-start
                align-items center
                width 350px
                margin-left 100px
                .PhoneWrapper
                    position relative
                    max-width 350px
                    width 100%
            &.FirstStep
                .StepMain
                    align-self center
                    justify-content center
                    align-items center
                .StepPreview
                    display none
    .BottomSheetSpaceFix
        flex 0 0 100px;
</style>
